import React, { useState, useEffect } from 'react';
import api from './api';

const BuyerMaster = () => {
    const [buyers, setBuyers] = useState([]);
    const [form, setForm] = useState({ 
        name: '', companyName: '', mobile: '', 
        panNumber: '', gstNumber: '', defaultTerms: 30 
    });

    const fetchBuyers = async () => {
        const res = await api.get('/buyers');
        setBuyers(res.data);
    };

    useEffect(() => { fetchBuyers(); }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.post('/buyers', form);
            alert("✅ Buyer Added!");
            setForm({ name: '', companyName: '', mobile: '', panNumber: '', gstNumber: '', defaultTerms: 30 });
            fetchBuyers();
        } catch (err) { alert("Error adding buyer"); }
    };

    return (
        <div className="container mt-4">
            <h4>Buyer Master (Customers)</h4>
            
            <div className="card p-3 mb-4 bg-light shadow-sm">
                <form onSubmit={handleSubmit}>
                    <div className="row g-2">
                        <div className="col-md-3">
                            <label className="small">Company Name</label>
                            <input className="form-control" value={form.companyName} onChange={e => setForm({...form, companyName: e.target.value})} required />
                        </div>
                        <div className="col-md-3">
                            <label className="small">Contact Person</label>
                            <input className="form-control" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
                        </div>
                        <div className="col-md-2">
                            <label className="small">Mobile</label>
                            <input className="form-control" value={form.mobile} onChange={e => setForm({...form, mobile: e.target.value})} />
                        </div>
                        <div className="col-md-2">
                            <label className="small">Default Terms (Days)</label>
                            <input type="number" className="form-control" value={form.defaultTerms} onChange={e => setForm({...form, defaultTerms: e.target.value})} />
                        </div>
                        <div className="col-md-2 align-self-end">
                            <button className="btn btn-success w-100">Add Buyer</button>
                        </div>
                    </div>
                </form>
            </div>

            <table className="table table-bordered">
                <thead className="table-dark">
                    <tr><th>Company</th><th>Person</th><th>Mobile</th><th>Terms</th></tr>
                </thead>
                <tbody>
                    {buyers.map(b => (
                        <tr key={b._id}>
                            <td>{b.companyName}</td>
                            <td>{b.name}</td>
                            <td>{b.mobile}</td>
                            <td>{b.defaultTerms} Days</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
export default BuyerMaster;